import { toASCII, toUnicode } from 'punycode';

export const EMAIL_REGEXP =
  /^[a-zA-Z0-9][a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]*(?:\.(?!-)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]{0,}[a-zA-Z0-9])*@(?!-)[\p{L}\p{N}-]*[\p{L}\p{N}](?:\.(?!-)[\p{L}\p{N}-]{1,}[\p{L}\p{N}]){1,2}$/u;

export const isEmail = (email: string): boolean => {
  const encodedEmail = encodePunycodeEmail(email);
  return EMAIL_REGEXP.test(encodedEmail);
};

export const encodePunycodeEmail = (email: string): string => {
  if (!email.includes('@')) return email;
  const [localPart, domain] = email.split('@');
  return `${localPart}@${toASCII(domain)}`;
};

export const decodePunycodeEmail = (email: string): string => {
  if (!email.includes('@')) return email;
  const [localPart, domain] = email.split('@');
  return `${localPart}@${toUnicode(domain)}`;
};
